export default __webpack_public_path__ + "static/media/Filter.6e21a881.svg";